import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { NumberText } from '@/components/functional/Format/NumberText/NumberText';
import { Text } from '@/components/ui/Typography/Body/Text';
const sizes = {
    md: {
        baseSize: 'md',
        secondarySize: 'lg',
    },
    sm: {
        baseSize: 'sm',
        secondarySize: 'sm',
    },
    xs: {
        baseSize: 'xs',
        secondarySize: 'xs',
    },
};
export const RfpProfessionalDaysLeftText = (props) => {
    const { className, daysLeft, size = 'md', tagName = 'span' } = props;
    // 残り日数がマイナスの場合は何も表示しない
    if (daysLeft < 0) {
        return null;
    }
    const Tag = tagName;
    return (_jsx(Tag, Object.assign({ className: className }, { children: _jsx("span", Object.assign({ className: 'inline-flex items-baseline' }, { children: daysLeft === 0 ? (_jsx(Text, Object.assign({ color: 'secondary', isBold: true, size: sizes[size].secondarySize, tagName: 'span' }, { children: "\u672C\u65E5\u7DE0\u5207" }))) : (_jsxs(_Fragment, { children: [_jsx(Text, Object.assign({ color: 'base', isBold: true, size: sizes[size].baseSize, tagName: 'span' }, { children: "\u6B8B\u308A" })), _jsx(Text, Object.assign({ color: 'secondary', isBold: true, size: sizes[size].secondarySize, tagName: 'span' }, { children: _jsx(NumberText, { value: daysLeft }) })), _jsx(Text, Object.assign({ color: 'base', isBold: true, size: sizes[size].baseSize, tagName: 'span' }, { children: "\u65E5" }))] })) })) })));
};
export const RfpProfessionalDaysLeftTextSizes = sizes;
